import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-primary">
              FonduriEU
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-600 hover:text-primary">Acasă</Link>
            <Link to="/projects" className="text-gray-600 hover:text-primary">Proiecte</Link>
            <Link to="/cum-functioneaza" className="text-gray-600 hover:text-primary">Cum Funcționează</Link>
            <Link to="/i-am-professional" className="text-gray-600 hover:text-primary">Sunt Profesionist</Link>
            <Link to="/publish-project" className="btn-primary">Publică un proiect</Link>
            <Link to="/autentificare" className="btn-secondary">Autentificare</Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-primary focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-600 hover:text-primary">Acasă</Link>
              <Link to="/projects" className="text-gray-600 hover:text-primary">Proiecte</Link>
              <Link to="/cum-functioneaza" className="text-gray-600 hover:text-primary">Cum Funcționează</Link>
              <Link to="/i-am-professional" className="text-gray-600 hover:text-primary">Sunt Profesionist</Link>
              <Link to="/publish-project" className="btn-primary w-full text-center">Publică un proiect</Link>
              <Link to="/autentificare" className="btn-secondary w-full text-center">Autentificare</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header; 